function Reference({ id, name, location, url, pageUrl }) {
  return (
    <div className="py-0.5 pr-5">
      <div className={`ft-icon ${url ? 'ft-pdf' : ''}`}>
        <span>
          {url ? (
            <a
              href={url}
              className="hover:underline text-secondary"
              data-modal="letter"
              data-modal-disable-default-close
              data-modal-update-url={`${pageUrl}letter/${id}`}
            >
              {name}
            </a>
          ) : (
            <strong>{name}</strong>
          )}
          {location && <span>&nbsp;- {location}</span>}
        </span>
      </div>
    </div>
  )
}

export default Reference
